import { formatIfPhone } from '../../utilities/format.js';
import EmailLink, { emailLinkMarkdown } from '../Link/EmailLink.js';
import { Variant } from '../Typography/index.js';

interface ContactInfoProps {
  email: string;
  phone?: string;
  variant?: Variant;
}

export default function PartnerContact({
  email,
  phone,
  variant = 'body',
}: ContactInfoProps): JSX.Element {
  return (
    <>
      {<EmailLink variant={variant}>{email}</EmailLink>}
      {phone && ` or ${formatIfPhone(phone)}`}
    </>
  );
}

export function contactInfoMarkdown({ email, phone }: ContactInfoProps): string {
  return [emailLinkMarkdown(email), phone && formatIfPhone(phone)].filter(Boolean).join(' or ');
}
